// tslint:disable
import * as classNames from "classnames";
import * as React from "react";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { globalActions } from "../../actions";

import { Alignment, Text } from "@blueprintjs/core";

import { StyledSwitch } from 'src/components';

import {
  Classes,
  IMPDSideBarProps,
  Justify,
  MPDButton,
  MPDSideBar,
  MPDSideBarDivider,
  MPDSideBarGroup,
  MPDSideItem
} from "src/mpd-library/";

import "./styles.css";

interface ISideBarProps extends IMPDSideBarProps {
  profileData: any;
  isMobileSize: boolean;
  windowHeight: number;
  routeProps: any;
  onToggleMobileSideBar: () => (dispatch: Dispatch<any>) => Promise<void>;
  onToggleProfileStatus: (
  ) => (dispatch: Dispatch<any>) => Promise<void>;
}

interface ISideBarState {
  showSwitchApps?: boolean;
  showProfile?: boolean;
}

class SideBar extends React.Component<ISideBarProps, ISideBarState> {
  constructor(props: ISideBarProps) {
    super(props);
    this.toggleSwitchApps = this.toggleSwitchApps.bind(this);
    this.toggleAccount = this.toggleAccount.bind(this);
    this.onClickSwitchApps = this.onClickSwitchApps.bind(this);
    this.renderAccount = this.renderAccount.bind(this);
    this.onDefaultClick = this.onDefaultClick.bind(this);

    this.state = {
      showSwitchApps: false,
      showProfile: false
    };
  }

  public render() {
    const { className, routeProps, profileData, isMobileSize, windowHeight, ...newProps } = this.props;
    const { showSwitchApps, showProfile } = this.state;

    if(profileData === null || profileData === undefined) {
      return null;
    }

    if (showSwitchApps && isMobileSize) {
      return this.renderMobileSwitchApps();
    }

    if (showProfile && isMobileSize) {
      return this.renderMobileAccount();
    }

    return (
      <MPDSideBar
        className={classNames(className, "portal-sidebar", 'main')}
        history={routeProps.history}
        {...newProps}
      >
        <MPDSideBarGroup justify={Justify.TOP} id="0" className="fixed">
          <MPDSideItem
            className="side-menu-logo"
            name="side-menu--icon--logo"
            text="Spot Alerts"
            path="/alerts"
            onItemClick={this.onDefaultClick}
            shouldActive={false}
            toolTipActive={false}
          />
        </MPDSideBarGroup>
        <MPDSideBarGroup justify={Justify.CENTER} id="1" yDirection={true}>
          <MPDSideItem
            className="side-menu-home"
            name="side-menu--icon--home-unselected"
            hoverName="side-menu--icon--home-hover"
            selectName="side-menu--icon--home-selected"
            path="/alerts"
            text="Home"
            onItemClick={this.onDefaultClick}
            alignIcon={Alignment.LEFT}
            toolTipActive={!isMobileSize && windowHeight > 250}
          />
          <MPDSideItem
            className="side-menu-analytics"
            name="side-menu--icon--alerts-analytics-unselected"
            hoverName="side-menu--icon--alerts-analytics-hover"
            selectName="side-menu--icon--alerts-analytics-selected"
            path="/analytics"
            text="Analytics"
            onItemClick={this.onDefaultClick}
            alignIcon={Alignment.LEFT}
            toolTipActive={!isMobileSize && windowHeight > 250}
          />
          <MPDSideItem
            className="side-menu-settings"
            name="side-menu--icon--settings-unselected"
            hoverName="side-menu--icon--settings-hover"
            selectName="side-menu--icon--settings-selected"
            path="/alerts-settings"
            text="Settings"
            onItemClick={this.onDefaultClick}
            alignIcon={Alignment.LEFT}
            toolTipActive={!isMobileSize && windowHeight > 250}
          />
        </MPDSideBarGroup>
        <MPDSideBarGroup justify={Justify.BOTTOM} id="2" className="fixed">
          <MPDSideItem
            className="side-menu-switch-apps"
            name="side-menu--icon--apps-unselected"
            hoverName="side-menu--icon--apps-hover"
            selectName="side-menu--icon--apps-selected"
            text="Switch Apps"
            shouldActive={false}
            onItemClick={this.toggleSwitchApps}
            popOverProps={{
              backdropProps: { className: 'sidebar-backdrop' },
              popoverClassName:'sidebar-switchapps-popover',
              content: this.renderSwitchApps(),
              canEscapeKeyClose: true,
              isOpen: this.state.showSwitchApps,
              hasBackdrop: true
            }}
            toolTipActive={!isMobileSize}
            alignIcon={Alignment.LEFT}
          />
          <MPDSideBarDivider />
          {isMobileSize ? (
            <MPDSideItem
              className="side-menu-account"
              name="side-menu--icon--user"
              text="Account"
              shouldActive={false}
              onItemClick={this.toggleAccount}
              alignIcon={Alignment.LEFT}
            />
          ) : (
            <MPDSideItem
              className="side-menu-account"
              name="side-menu--icon--user"
              text="Account"
              shouldActive={false}
              onItemClick={this.toggleAccount}
              toolTipActive={!isMobileSize}
              popOverProps={{
                backdropProps: { className: 'sidebar-backdrop' },
                popoverClassName:'sidebar-account-popover',
                content: this.renderAccount(),
                isOpen: this.state.showProfile,
                canEscapeKeyClose: true,
                hasBackdrop: true
              }}
              alignIcon={Alignment.LEFT}
            />
          )}
        </MPDSideBarGroup>
      </MPDSideBar>
    );
  }

  private onDefaultClick() {
    const { isMobileSize } = this.props;
    if(isMobileSize){
      this.props.onToggleMobileSideBar();
    }
    if(this.state.showSwitchApps){
      this.toggleSwitchApps();
    }
    if(this.state.showProfile){
      this.toggleAccount();
    }
  }

  private toggleAccount() {
    this.props.onToggleMobileSideBar;
    if(this.state.showSwitchApps){
      this.toggleSwitchApps();
    }
    this.setState({ showProfile: !this.state.showProfile });
  }

  private toggleSwitchApps() {
    if(this.state.showProfile){
      this.toggleAccount();
    }
    this.setState({ showSwitchApps: !this.state.showSwitchApps });
  }

  private renderSwitchApps() {
    let currentApp;
    if (this.props.routeProps.history) {
      currentApp = this.props.routeProps.history.location.pathname.replace("/", "");
    }
    return (
      <div className="switch-apps" onClick={e => e.stopPropagation()}>
        <div className="switch-apps-inner">
          <MPDButton
            className={classNames(currentApp === "alerts" && Classes.ACTIVE)}
            name="side-menu--icon--logo-dark"
            text="Alerts"
            onClick={this.onClickSwitchApps}
            justifyIcon={Justify.TOP}
          />
          <MPDButton
            name="side-menu--icon--tips"
            justifyIcon={Justify.TOP}
            className={classNames(currentApp === "tips" && Classes.ACTIVE)}
            text="Tips"
          />
        </div>
        <div className="switch-apps-inner">
          <MPDButton
            className={classNames(currentApp === "dashboard" && Classes.ACTIVE)}
            justifyIcon={Justify.TOP}
            name="side-menu--icon--dashboard"
            text="Dashboard"
          />
          <MPDButton
            className={classNames(currentApp === "analytics" && Classes.ACTIVE)}
            justifyIcon={Justify.TOP}
            name="side-menu--icon--analytics"
            text="Analytics"
          />
        </div>
      </div>
    );
  }

  private renderMobileAccount() {
    const { className, profileData, routeProps, isMobileSize,  ...newProps } = this.props;
    const { name, initials, status } = profileData;

    return (
      <MPDSideBar
        className={classNames(className, "portal-sidebar", "mobile-account")}
        history={routeProps.history}
        {...newProps}
      >
        <MPDSideBarGroup justify={Justify.TOP} >
          <MPDSideItem
            className="side-menu-back-mobile"
            name="side-menu-back"
            text="Account"
            shouldActive={false}
            onItemClick={this.toggleAccount}
          />
          <MPDSideBarDivider />
          <div className="profile-info">
            <Text className="initials"> { initials } </Text>
            <div>
              <Text className="name"> { name } </Text>
              <Text className="status"> { status ? 'Away' : 'Active' } </Text>
            </div>
          </div>
          <MPDSideBarDivider />
          <div className="status-control">
            <StyledSwitch checked={status} onChange={this.props.onToggleProfileStatus} label="Away Mode" alignIndicator={Alignment.RIGHT} />
          </div>
          <MPDSideBarDivider />
        </MPDSideBarGroup >
        <MPDSideBarGroup yDirection={true}>
          <MPDSideItem
              className="side-menu-settings"
              name="settings-icon-active"
              text="Settings"
              path='/alerts'
              // onItemClick={this.onDefaultClick}
          />
          <MPDSideItem
            className="side-menu-account"
            name="account-icon-active"
            text="My Account"
            path='/alerts'
            // onItemClick={this.onDefaultClick}
          />
          <MPDSideItem
            className="side-menu-billing"
            name="billing-icon-active"
            text="Billing"
            path='/alerts'
            // onItemClick={this.onDefaultClick}
          />
        </MPDSideBarGroup>
        <MPDSideBarGroup justify={Justify.BOTTOM}>
          <MPDSideBarDivider />
          <MPDSideItem 
            className="side-menu-bottom" 
            text="Help Center" 
            path='/alerts'
            // onItemClick={this.onDefaultClick}
          />
          <MPDSideItem 
            className="side-menu-bottom" 
            text="Status Page" 
            path='/alerts'
            // onItemClick={this.onDefaultClick}
          />
          <MPDSideBarDivider />
          <MPDSideItem
            className="side-menu-bottom"
            path="/signout"
            text="Logout"
            // onItemClick={this.onDefaultClick}
          />
        </MPDSideBarGroup>
      </MPDSideBar>
    );
  }

  private renderMobileSwitchApps() {
    const { className, routeProps, isMobileSize, ...newProps } = this.props;
    return (
      <MPDSideBar
        className={classNames(
          className,
          "portal-sidebar",
          "mobile-switch-apps"
        )}
        history={routeProps.history}
        {...newProps}
      >
        <MPDSideBarGroup justify={Justify.CENTER} id="01" yDirection={true}>
          <MPDSideItem
            className="side-menu-back-mobile"
            name="side-menu-back"
            path='/alerts'
            text="Switch Apps"
            shouldActive={false}
            onItemClick={this.toggleSwitchApps}
          />
          <MPDSideItem
            className="side-menu-alerts-mobile"
            name="side-menu--icon--alerts"
            text="Alerts"
            path="/alerts"
          />
          <MPDSideItem
            className="side-menu-reports-mobile"
            name="side-menu-reports"
            path="/alerts"
            text="Reports"
            alignIcon={Alignment.LEFT}
          />
          <MPDSideItem
            className="side-menu-dashboard-mobile"
            name="side-menu-dashboard"
            path="/alerts"
            text="Dashboard"
            alignIcon={Alignment.LEFT}
          />
          <MPDSideItem
            className="side-menu-analytics-mobile"
            name="side-menu-analytics"
            path="/alerts"
            text="Analytics"
            alignIcon={Alignment.LEFT}
          />
        </MPDSideBarGroup>
      </MPDSideBar>
    );
  }

  private renderAccount() {
    const { profileData } = this.props;
    const { name, status, initials } = profileData;
    return (
      <div className="account-container" onClick={e => e.stopPropagation()}>
        <div className="profile-info">
          <Text className="initials"> { initials } </Text>
          <div>
            <Text className="name"> { name } </Text>
            <Text className="status"> { status ? 'Away' : 'Active' } </Text>
          </div>
        </div>
        <div className="status-control">
          <StyledSwitch checked={status} onChange={this.props.onToggleProfileStatus} label="Away Mode" alignIndicator={Alignment.RIGHT} />
        </div>
        <div className="menu-container">
          <div className="inner-container">
            <MPDButton
              className="settings"
              name="settings-icon"
              text="Settings"
            />
            <MPDButton
              className="account"
              name="account-icon"
              text="My Account"
            />
            <MPDButton className="billing" name="billing-icon" text="Billing" />
            <div />
          </div>
          <div className="inner-container">
            <MPDButton text="Help Center" />
            <MPDButton text="Status Page" />
          </div>
          <div className="inner-container">
            <MPDButton
              onClick={e =>
                this.props.routeProps.history && this.props.routeProps.history.push("/signout")}
              text="Logout"
            />
          </div>
        </div>
      </div>
    );
  }

  private onClickSwitchApps() {
    if (this.props.routeProps.history) {
      this.props.routeProps.history.push("/testing");
    }
  }
}

const mapStateToProps = (state: any) => {
  const { global } = state;
  const { profileData, isMobileSize, windowHeight } = global;

  return {
    profileData,
    isMobileSize,
    windowHeight
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onToggleProfileStatus: bindActionCreators(globalActions.onToggleProfileStatus, dispatch),
    onToggleMobileSideBar: bindActionCreators(
      globalActions.onToggleMobileSideBar,
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);




// WEBPACK FOOTER //
// ./src/controllers/sidebar/sidebar.tsx